import { render } from "./pre-register.vue?vue&type=template&id=03475019&scoped=true"
import script from "./pre-register.vue?vue&type=script&lang=js"
export * from "./pre-register.vue?vue&type=script&lang=js"

import "./pre-register.vue?vue&type=style&index=0&id=03475019&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03475019"]])

export default __exports__